import {
  createSlice,
  isFulfilled,
  isPending,
  isRejected,
} from '@reduxjs/toolkit';

import {
  updateCourseAsAdminSavingSlice,
  updateCourseSectionAsAdminSavingSlice,
  updateCourseSectionsSortingAsAdminSavingSlice,
} from './adminApi';
import { RootState } from '../..';
import {
  updateCourseAsUserSavingSlice,
  updateCourseSectionAsUserSavingSlice,
  updateCourseSectionsSortingAsUserSavingSlice,
} from './api';

export interface IInitialSavingState {
  status: 'idle' | 'loading' | 'rejected';
}

const initialState: IInitialSavingState = {
  status: 'idle',
};

const SAVING_ACTIONS = [
  updateCourseAsAdminSavingSlice,
  updateCourseSectionAsAdminSavingSlice,
  updateCourseSectionsSortingAsAdminSavingSlice,
  updateCourseAsUserSavingSlice,
  updateCourseSectionAsUserSavingSlice,
  updateCourseSectionsSortingAsUserSavingSlice,
] as const;

export const SavingSlice = createSlice({
  name: 'saving',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Matchers
    builder
      .addMatcher(isPending(...SAVING_ACTIONS), (state) => {
        state.status = 'loading';
      })
      .addMatcher(isFulfilled(...SAVING_ACTIONS), (state) => {
        state.status = 'idle';
      })
      .addMatcher(isRejected(...SAVING_ACTIONS), (state) => {
        state.status = 'rejected';
      });
  },
});

export const getSavingState = (state: RootState): RootState['saving'] =>
  state.saving;

export * from './adminApi';
export * from './api';
export default SavingSlice.reducer;
